let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6Tx9y")).then(() => parcelRequire('4sMWb'));